import { render, staticRenderFns } from "./NoticeForm.vue?vue&type=template&id=2a2b18ee&scoped=true&"
import script from "./NoticeForm.vue?vue&type=script&lang=js&"
export * from "./NoticeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b18ee",
  null
  
)

export default component.exports